import React from 'react';
import { T, Lang } from '../lib/i18n';
interface FooterProps {
  lang: Lang;
  openPrivacy: () => void;
  openTerms: () => void;
}
export function Footer({
  lang,
  openPrivacy,
  openTerms
}: FooterProps) {
  const t = T[lang].footer;
  const tn = T[lang].nav;
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="bg-brand-navy-dark text-white pt-20 pb-8 px-4 md:px-8" data-id="element-68">
      <div className="max-w-7xl mx-auto" data-id="element-69">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-70">
          {/* Col 1 - Brand */}
          <div className="space-y-6" data-id="element-71">
            <div className="flex items-center space-x-3" data-id="element-72">
              <svg width="40" height="40" viewBox="0 0 60 104" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-73">
                <path d="M30 104L0 86.679V52L30 34.679L60 52V86.679L30 104ZM30 100.536L57 84.947V53.732L30 38.143L3 53.732V84.947L30 100.536Z" fill="white" data-id="element-74" />
                <path d="M30 69.321L0 52V17.321L30 0L60 17.321V52L30 69.321ZM30 65.857L57 50.268V19.053L30 3.464L3 19.053V50.268L30 65.857Z" fill="white" data-id="element-75" />
                <text x="30" y="65" fontFamily="Syne" fontSize="32" fontWeight="bold" fill="white" textAnchor="middle" data-id="element-76">
                  A
                </text>
              </svg>
              <div data-id="element-77">
                <div className="font-display font-bold text-xl tracking-wide" data-id="element-78">
                  ARVEX
                </div>
                <div className="font-body text-[0.5rem] tracking-[0.2em] uppercase opacity-80" data-id="element-79">
                  Holding LLC
                </div>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-80">{t.desc}</p>
            <div className="space-y-2 text-sm text-white/80" data-id="element-81">
              <p data-id="element-82">📧 support@iapilotsociety.com</p>
              <p data-id="element-83">📞 +1 (321) 332-5840</p>
              <p data-id="element-84">📍 Orlando, Florida, USA</p>
            </div>
          </div>

          {/* Col 2 - Servicios */}
          <div data-id="element-85">
            <h4 className="font-display font-bold text-lg mb-6" data-id="element-86">
              {tn.services}
            </h4>
            <ul className="space-y-3 text-sm text-white/70" data-id="element-87">
              <li data-id="element-88">
                <button onClick={() => scrollTo('servicios')} className="hover:text-brand-blue-bright transition-colors" data-id="element-89">
                  Diseño Web / Web Design
                </button>
              </li>
              <li data-id="element-90">
                <button onClick={() => scrollTo('servicios')} className="hover:text-brand-blue-bright transition-colors" data-id="element-91">
                  SEO & Posicionamiento
                </button>
              </li>
              <li data-id="element-92">
                <button onClick={() => scrollTo('servicios')} className="hover:text-brand-blue-bright transition-colors" data-id="element-93">
                  Google Business
                </button>
              </li>
              <li data-id="element-94">
                <button onClick={() => scrollTo('servicios')} className="hover:text-brand-blue-bright transition-colors" data-id="element-95">
                  Generación de Leads
                </button>
              </li>
            </ul>
          </div>

          {/* Col 3 - Paquetes */}
          <div data-id="element-96">
            <h4 className="font-display font-bold text-lg mb-6" data-id="element-97">
              {tn.packages}
            </h4>
            <ul className="space-y-3 text-sm text-white/70" data-id="element-98">
              <li data-id="element-99">
                <button onClick={() => scrollTo('paquetes')} className="hover:text-brand-blue-bright transition-colors" data-id="element-100">
                  Plan Básico
                </button>
              </li>
              <li data-id="element-101">
                <button onClick={() => scrollTo('paquetes')} className="hover:text-brand-blue-bright transition-colors" data-id="element-102">
                  Plan Profesional
                </button>
              </li>
              <li data-id="element-103">
                <button onClick={() => scrollTo('paquetes')} className="hover:text-brand-blue-bright transition-colors" data-id="element-104">
                  Plan Premium
                </button>
              </li>
            </ul>
          </div>

          {/* Col 4 - Legal */}
          <div data-id="element-105">
            <h4 className="font-display font-bold text-lg mb-6" data-id="element-106">
              Legal & Contact
            </h4>
            <ul className="space-y-3 text-sm text-white/70" data-id="element-107">
              <li data-id="element-108">
                <button onClick={openPrivacy} className="hover:text-brand-blue-bright transition-colors" data-id="element-109">
                  {t.priv}
                </button>
              </li>
              <li data-id="element-110">
                <button onClick={openTerms} className="hover:text-brand-blue-bright transition-colors" data-id="element-111">
                  {t.terms}
                </button>
              </li>
              <li data-id="element-112">
                <button onClick={() => scrollTo('contacto')} className="hover:text-brand-blue-bright transition-colors" data-id="element-113">
                  {tn.contact}
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/60" data-id="element-114">
          <p data-id="element-115">{t.rights}</p>
          <div className="flex space-x-4" data-id="element-116">
            <button onClick={openPrivacy} className="hover:text-white transition-colors" data-id="element-117">
              Privacidad
            </button>
            <button onClick={openTerms} className="hover:text-white transition-colors" data-id="element-118">
              Términos
            </button>
          </div>
        </div>
      </div>
    </footer>;
}